module.exports = __webpack_public_path__ + "static/media/upload.00fe0eea.svg";